export default class SqlDateValidator {
    private static readonly SQL_DATE_FORMAT_REGEX: string = "^[1-9]\\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\\d|3[01])$";

    public static isValid(dateString: string): boolean {
        return new RegExp(this.SQL_DATE_FORMAT_REGEX, 'g').test(dateString);
    }
}
